module.exports = __webpack_public_path__ + "volum_circle1.png?559686c6c8d66734a084338df0cb0d55";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volum_circle1.png
// module id = 688
// module chunks = 0